(function () {

    /**
     * Service abstraction for segment analytics
     */
    class AnalyticsService {
        constructor(segment) {
            this.segment = segment;
        }

        /**
         * @param {string} title
         * @param {object} properties
         * @param {string} properties.url the absolute url of the page being navigated to
         * @param {string} properties.path the relative url path
         * @throws Error if the page title and/or properties are not given
         */
        page(title, properties) {
            if (!title) {
                throw Error("The title must be defined");
            }
            if (!properties || typeof properties  !== "object") {
                throw Error("The properties must be provided, as an object");
            }
            if (!properties.path) {
                throw Error("The path must be defined in page properties");
            }
            if (!properties.url) {
                throw Error("The url must be defined in page properties");
            }
            this.segment.page(title, properties);
        }

        /**
         * @param {number} userId
         * @param {object} traits
         * @throws Error if the user id and/or traits are not given
         */
        identify(userId, traits) {
            if (!userId) {
                throw Error("The userId must be defined for the user being identified");
            }
            if (!traits || typeof traits !== "object") {
                throw Error("User traits must be passed, as an object");
            }
            this.segment.identify(userId, traits);
        }
    }

    angular.module("dashboard")
        .service("AnalyticsService", ["segment", AnalyticsService ])
})();
